import { useEffect, useLayoutEffect, useRef } from 'react';
import { throttle } from 'lodash';
import { useBuilderStore } from './store';

// preserve scroll position when pinned items prepended to the DOM, so there is no content shift
function useScrollPreservation() {
  const pinnedAccommodationMap = useBuilderStore(state => state.data.pinnedAccommodationMap);
  const previousScrollPos = useRef(0);
  const previousContainerHeight = useRef(0);
  useLayoutEffect(() => {
    const nextHeight = document.querySelector('[data-test-id="pinned-accommodations-list"]')?.scrollHeight;
    if (nextHeight !== previousContainerHeight?.current) {
      let delta = nextHeight - previousContainerHeight.current;

      // auto pinning first item, this could be refactored to be a bit more robust
      if (previousContainerHeight.current === 10) {
        // margin bottom + flex gap not included
        delta = delta + 56;
      }

      requestAnimationFrame(() => {
        window.scrollTo({ top: previousScrollPos.current + delta, behavior: 'instant' });
      });
    }
  }, [pinnedAccommodationMap]);

  // Always Update Measurement Refs when layout is recalculated
  useLayoutEffect(() => {
    previousScrollPos.current = window?.scrollY;
    const list = document.querySelector('[data-test-id="pinned-accommodations-list"]');
    if (list) {
      previousContainerHeight.current = list?.scrollHeight ?? 0;
    }
  });

  // recapture sizes on scroll/resize
  useEffect(() => {
    const throttledHandler = throttle(() => {
      previousScrollPos.current = window?.scrollY;

      const list = document.querySelector('[data-test-id="pinned-accommodations-list"]');
      if (list) {
        previousContainerHeight.current = list.scrollHeight ?? 0;
      }
    }, 20);

    window.addEventListener('scroll', throttledHandler, true);
    window.addEventListener('resize', throttledHandler);

    throttledHandler();

    return () => {
      window.removeEventListener('scroll', throttledHandler, true);
      window.removeEventListener('resize', throttledHandler);
    };
  }, []);
}

export default useScrollPreservation;
